export const truncateText = (str: string, max = 10): string => {
  const array = str.trim().split(/\s+/);
  const ellipsis = array.length > max ? "…" : "";

  return array.slice(0, max).join(" ") + ellipsis;
};
